import React from 'react';
import { Step } from 'react-joyride';

import SZJoyride from 'buyside/components/presentation/Joyride/szJoyride';
import { ideaIndexJoyrideSteps } from 'buyside/components/presentation/Joyride/IdeaIndexJoyride/ideaIndexJoyrideHelper';

import { optOutJoyride, shouldHideJoyride } from 'buyside/util/joyrideUtil';

const joyrideCookieName = 'hideIdeaIndexJoyride';

const IdeaIndexJoyride: React.FC<{ canWriteIdeas: boolean }> = ({ canWriteIdeas }) => {
  if (shouldHideJoyride(joyrideCookieName)) return null;

  const steps: Step[] = [
    ideaIndexJoyrideSteps.savedSearches,
    ideaIndexJoyrideSteps.ideaCard,
    ...(canWriteIdeas ? [ideaIndexJoyrideSteps.submitResearch] : [])
  ];

  return (
    <SZJoyride
      callback={({ status }): void => optOutJoyride(status, joyrideCookieName)}
      continuous
      spotlightClicks
      steps={steps}
    />
  );
};

export default IdeaIndexJoyride;
